import campaignClose from '../media/campaignClose.png?url'
import { assetSrc } from '../media/media-asset.util'
import { ThemeButton } from './ThemeButton'

type Props = {
  onClose: () => void
}

export function SurveyAnswerCampaignClose({ onClose }: Props) {
  const imgSrc = assetSrc(campaignClose)

  return (
    <div className="relative flex h-full items-center justify-center">
      <div className="space-y-4 px-6">
        <h3 className="text-center text-xl font-bold">
          キャンペーンは終了しています
        </h3>
        <div className="flex items-center justify-center">
          <img
            src={imgSrc}
            alt="キャンペーン終了"
            className="inline-block w-[186px]"
          />
        </div>
        <div>
          こちらのキャンペーンは既に終了しているため編集することができません。
        </div>
      </div>
      <div className="absolute bottom-0 flex w-full gap-4 p-6">
        <ThemeButton
          className="font-semibold"
          onClick={onClose}
        >
          戻る
        </ThemeButton>
      </div>
    </div>
  )
}
